import axios from '@/axios'
import {setCookie} from '@/cookies-helper'

export default {
  updateUser(user) {
    return axios.put(`/users/${user._id}`, user).then(response => {
      let date = new Date()
      date.setDate(date.getDate() + 30)
      setCookie('token', response.data.token, date)
      axios.defaults.headers.common.authorization = response.data.token
        ? response.data.token
        : ''
    })
  }
}
